import { render, staticRenderFns } from "./Match.vue?vue&type=template&id=448e4098&"
import script from "./Match.vue?vue&type=script&lang=ts&"
export * from "./Match.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports